import * as Sentry from '@sentry/react';
import { AnyEventObject } from 'xstate';

import { isDevelopment } from 'src/shared/helpers/environment';

function logError<TContext>(_: TContext, event: AnyEventObject) {
  if (isDevelopment()) {
    // eslint-disable-next-line no-console
    console.error('Machine error\n', event);
  } else {
    Sentry.captureException(event.data);
  }
}

// generic actions that can be shared between machines
const sharedActions = {
  logError,
};

export { sharedActions };
